/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickettypenotfounderror4Inputs */

const en_tickettypenotfounderror4 = /** @type {(inputs: Tickettypenotfounderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This ticket type no longer exists.`)
};

const de_tickettypenotfounderror4 = /** @type {(inputs: Tickettypenotfounderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Ticketart gibt es nicht mehr.`)
};

/**
* | output |
* | --- |
* | "This ticket type no longer exists." |
*
* @param {Tickettypenotfounderror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tickettypenotfounderror4 = /** @type {((inputs?: Tickettypenotfounderror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickettypenotfounderror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tickettypenotfounderror4(inputs)
	return de_tickettypenotfounderror4(inputs)
});
export { tickettypenotfounderror4 as "ticketTypeNotFoundError" }